import { countries } from '../../organisations/root/forms/items/personal-form-items';

const EURO_WHOLE = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const EURO_CENTS = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });

/** 249000 → "2.490 €", 249050 → "2.490,50 €" – cents only when there are any. */
export const formatEuro = (cents: number): string => (cents % 100 === 0 ? EURO_WHOLE : EURO_CENTS).format(cents / 100);

// Start dates are midnight server time – German time shows the intended day wherever the customer is.
const DATE_FORMAT = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' });

/** "2026-11-15T00:00:00.000Z" → "15.11.2026" */
export const formatDate = (isoDate: string): string => DATE_FORMAT.format(new Date(isoDate));

/** Like `isIBAN`/`isBIC` in the backend: spaces and hyphens are ignored, lower case is fine. */
export const compactBankValue = (value: string): string => value.replace(/[\s-]/g, '').toUpperCase();

/** Country code + check digits and the last four characters stay visible, like in the contract mail. */
export const maskIban = (iban: string): string => {
  const compact = compactBankValue(iban);
  const masked = compact.slice(0, 4) + '*'.repeat(Math.max(compact.length - 8, 0)) + compact.slice(-4);
  return masked.replace(/(.{4})(?=.)/g, '$1 ');
};

/** "DE" → "Deutschland" – same list as the country select. */
export const getCountryLabel = (code: string): string => countries.find((country) => country.value === code)?.label ?? code;
